import React, { useEffect, useState } from "react";

import styled from "styled-components/macro";

import API from "Payments/FundItPage/API";
import { useFundItSignupProgress } from "Payments/FundItPage/useFundItSignupProgress";

import CloseButton from "./CloseButton";
import LearnMore from "./LearnMore";
import MoreSetupNeeded from "./MoreSetupNeeded";
import SetupComplete from "./SetupComplete";
import TitleSection from "./TitleSection";
import { mockStatus, shouldMock } from "./mockData";
import { SplashWrapper } from "./styles";

export default function FundItSignupSplash({ status, settings }) {
  const [displayCloseBtn, setDisplayCloseBtn] = useState(false);
  const [closed, setClosed] = useState(false);
  const progress = useFundItSignupProgress(shouldMock ? mockStatus : status);

  settings = shouldMock
    ? {
        shouldShowPaymentsInfoSplash: true,
        shouldShowPaymentsSetupSplash: false,
      }
    : settings;

  const handleClose = async () => {
    // API call to tell db not so show this again
    await API.dismissPaymentsSplash().post();
    setClosed(true);
  };

  useEffect(
    function showCloseButtonBasedOnProgress() {
      // if the user is at the 'needToEnterKYC', 'needToEnterBankInfo, or 'hasKYCValidationError' step, then they can't disable the payments splash
      let cantCloseStates = [
        "needToEnterKYC",
        "needToEnterBankInfo",
        "hasKYCValidationError",
      ];
      setDisplayCloseBtn(!cantCloseStates.includes(progress.state));
    },
    [progress]
  );

  const renderSetupContent = () => {
    const { splashView } = progress;

    if (splashView === "learnMore") {
      return <LearnMore />;
    } else if (splashView === "moreSetupNeeded") {
      return <MoreSetupNeeded progress={progress} settings={settings} />;
    } else if (splashView === "setupComplete") {
      return <SetupComplete />;
    } else {
      return null;
    }
  };

  if (
    closed ||
    settings.networkHasNonUSAddress ||
    settings.shouldShowPaymentsInfoSplash ||
    !settings.shouldShowPaymentsSetupSplash
  ) {
    return null;
  }

  // for Super Admins before signup, during setup, and up to 30 days after setup is complete
  return (
    <SplashWrapper>
      <CloseButton show={displayCloseBtn} handleClose={handleClose} />
      <PageTop>
        <TitleSection />
      </PageTop>
      <PageBottom>{renderSetupContent()}</PageBottom>
    </SplashWrapper>
  );
}

const PageTop = styled.div`
  padding-bottom: 20px;
  position: relative;
  filter: drop-shadow(0 0 8px rgba(0, 0, 0, 0.6));
  &::before {
    position: absolute;
    content: "";
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: -1;
    clip-path: polygon(0% 0%, 100% 0%, 100% calc(100% - 40px), 0% 100%);
    background-image: linear-gradient(
      197deg,
      rgb(1, 96, 153) 0%,
      rgb(19, 66, 107) 100%
    );
  }
`;

const PageBottom = styled.div`
  padding: 0 30px 30px;
  @media screen and (max-width: 590px) {
    padding: 0 20px 30px;
  }
`;
